module.exports = __webpack_public_path__ + "static/character-4-51d355fa3226cfe886b809779475a8fc.svg";